module.exports = __webpack_public_path__ + "static/media/bronze_test_banner_zh.c9e7376c.png";